// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"2f755183","315":"519cea63","409":"d4822ea6","631":"ab8fce6f","771":"936a8f67","774":"a199f36b","787":"325cd88c"}[chunkId] + ".chunk.js";
};